module.exports = __webpack_public_path__ + "img/logout-grey56.fb175d38.svg";